import { cloneDeep } from '@src/utils/functions/utils'

const pageExperimentState = {
  assignedBuckets: {} as Record<string, string>,
}

export const setBucketForPageExperiment = (experimentName: string, bucketName: string) => {
  pageExperimentState.assignedBuckets[experimentName] = bucketName
}

export const getPageExperimentAssignedBuckets = () =>
  cloneDeep(pageExperimentState.assignedBuckets) as Record<string, string>

export const getAssignedBucketForPageExperiment = (experimentName: string) =>
  pageExperimentState.assignedBuckets[experimentName]
